import React, { useState, useEffect } from 'react'
import styles from './work-groups-container.module.scss'
import classNames from 'classnames'
import WorkGroupCard from '../WorkGroupCard'
import { useTranslation } from 'react-i18next'
import AlertComponent from '@BUP/components/Generics/Alert'
const WorkGroupsContainer = ({
  data,
  mediatorState,
  newLinksState,
  preferencesState,
  selectButtonState
}) => {
  const [t] = useTranslation()
  const classNameGroupsWrapper = classNames(`${styles.work_groups_wrapper}`, {
    [styles.wrapper_four_group]: selectButtonState === 4,
    [styles.wrapper_six_group]: selectButtonState === 6
  })

  const [groupSolutions, setGroupSolutions] = useState(null)

  const generateWorkGroupCards = group => {
    const groups =
      (group &&
        group.map((group, i) => (
          <WorkGroupCard
            key={i}
            dataGroup={group}
            index={i}
            selectButtonState={selectButtonState}
          />
        ))) ||
      null
    return groups
  }

  useEffect(() => {
    let newGroupSolutions = null

    const getGroupsSolution = (indicator, targetConfigMin) => {
      const groupSolution =
      data &&
      data.length > 0 &&
      data.find(elem => elem[indicator].target.config.min === targetConfigMin)

      return groupSolution ? groupSolution[indicator].solution : null
    }
    if (mediatorState) {
      if (selectButtonState === 2) {
        newGroupSolutions = getGroupsSolution('betweenness', 2)
      } else if (selectButtonState === 4) {
        newGroupSolutions = getGroupsSolution('betweenness', 4)
      } else if (selectButtonState === 6) {
        newGroupSolutions = getGroupsSolution('betweenness', 5)
      }
    } else if (newLinksState) {
      if (selectButtonState === 2) {
        newGroupSolutions = getGroupsSolution('remoteness', 2)
      } else if (selectButtonState === 4) {
        newGroupSolutions = getGroupsSolution('remoteness', 4)
      } else if (selectButtonState === 6) {
        newGroupSolutions = getGroupsSolution('remoteness', 5)
      }
    } else if (preferencesState) {
      if (selectButtonState === 2) {
        newGroupSolutions = getGroupsSolution('affinity', 2)
      } else if (selectButtonState === 4) {
        newGroupSolutions = getGroupsSolution('affinity', 4)
      } else if (selectButtonState === 6) {
        newGroupSolutions = getGroupsSolution('affinity', 5)
      }
    }
    setGroupSolutions(newGroupSolutions)
  }, [data, mediatorState, newLinksState, preferencesState, selectButtonState])

  if (!data) return <AlertComponent message={t('pages.data.dashBoardSociogram.errorGroupMessage')} type='error' />
  return (
    <div className={styles.container}>
      <div className={classNameGroupsWrapper}>
        {generateWorkGroupCards(groupSolutions)}
      </div>
    </div>
  )
}

export default WorkGroupsContainer
